export default () => ({
  activeStep: 0,
  type: undefined,
  document: undefined,
  list: [],
  activeFilters: {},
  orders: [],
  lastOrders: [],
  ordersString: '',
  isLoadingOrders: false,
  autocompleteSource: null,
  ordersSearchResult: [],
});
